<template>
  <div>
    <v-card flat class="mb-3">
      <div class="v-card-h1">Dane osobowe</div>

      <v-card-text class="error-top v-card-form__content mt-8">
        <w-input
          append-icon="mdi-account"
          name="name"
          placeholder="Jan"
          outlined
          :disabled="!canUpdateProfile"
          :model="schema.profile.firstName"
        />

        <w-input
          append-icon="mdi-account"
          name="surname"
          placeholder="Kowalski"
          outlined
          :disabled="!canUpdateProfile"
          :model="schema.profile.lastName"
        />

        <w-date-picker
          append-icon="mdi-calendar"
          name="date"
          placeholder="01.01.1990"
          outlined
          :disabled="!canUpdateProfile"
          :model="schema.profile.birthDate"
        />

        <w-select
          append-icon="mdi-account"
          name="gender"
          outlined
          item-text="text"
          item-value="value"
          :items="gender"
          :disabled="!canUpdateProfile"
          :model="schema.profile.gender"
        />

        <w-input
          append-icon="mdi-phone"
          name="phone"
          placeholder="888 888 888"
          outlined
          :disabled="!canUpdateProfile"
          :model="schema.profile.phoneNumber"
        />
      </v-card-text>

      <div class="v-card-h1">Adres</div>

      <v-card-text class="error-top px-0 mt-8">
        <teryt-form :disabled="!canUpdateProfile" :schema="schema.profile" />

        <w-input placeholder="--" outlined :disabled="!canUpdateProfile" :model="schema.profile.homeNumber" />

        <w-input placeholder="--" outlined :disabled="!canUpdateProfile" :model="schema.profile.localNumber" />
      </v-card-text>

      <v-card-actions v-if="$slots.actions">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { WInput, WSelect, WDatePicker } from '@witkac/vuetify-components';
import { Gender, GenderTranslation, CardState } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import TerytForm from '@/components/forms/TERYTForm';

// @vuese
// Formularz danych klienta
// @group Forms
export default {
  components: { WInput, WSelect, TerytForm, WDatePicker },
  props: {
    // schema profilu
    schema: { type: Object, required: true }
  },
  data() {
    return {
      gender: [
        { text: GenderTranslation[Gender.FEMALE], value: Gender.FEMALE },
        { text: GenderTranslation[Gender.MALE], value: Gender.MALE }
      ]
    };
  },
  computed: {
    ...mapState({
      canUpdateProfile: state => {
        const applications = state.application.list;
        const cards = state.card.list;
        return (
          (!cards.length && !applications.length) || cards.every(card => CardState[card.state] === CardState.INACTIVE)
        );
      }
    })
  },
  watch: {
    'schema.profile.simc.$value'(newVal, prevVal) {
      if (newVal !== prevVal) {
        this.schema.profile.homeNumber.$setData('');
        this.schema.profile.localNumber.$setData('');
        this.schema.profile.postalCode.$setData('');
      }
    }
  }
};
</script>
